import React, { useState } from "react";

import { CommonCheckbox, CommonSelect } from "common/components";
import { CustomerInfo } from "shared/customer-info/CustomerInfo";
import { DocumentType } from "services/fake/fakeDocumentManager";
import { DownloadButton } from "shared/download-button/DownloadButton";
import { Grid, Card, Button } from "@material-ui/core";
import { Payment } from "common/store/payment/types";
import { ShareInfo } from "shared/share-info/ShareInfo";
import { StoreState } from "common/store/types";
import { User } from "common/store/user/types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

export const SummarySubform = ({
  errors,
  setFieldValue,
  values,
  touched,
  onAddPaymentMethods,
}: any) => {
  //State
  const [downloadedOne, setDownloadedOne] = useState(false);
  const [downloadedTwo, setDownloadedTwo] = useState(false);

  //Hooks
  const storageUserDetails = useSelector<StoreState, User>(
    (state) => state.currentUser
  );
  const { t } = useTranslation();

  //Options
  const paymentOptions = storageUserDetails.payment_accounts.map(
    (account: Payment) => {
      return { label: account.IBAN, value: account.id };
    }
  );

  return (
    <Card>
      <Grid container direction="row" spacing={6}>
        <Grid item lg={6}>
          <CustomerInfo variant="secondary" />
        </Grid>

        <Grid
          item
          lg={6}
          container
          direction="column"
          className="download-buttons-container"
        >
          <Grid item>
            <DownloadButton
              className="default"
              file={DocumentType.AgentInfo}
              text={t("Download agent information")}
              onClick={() => setDownloadedOne(true)}
            />
          </Grid>

          <Grid item>
            <DownloadButton
              className="default"
              file={DocumentType.Prospectus}
              text={t("Download prospectus")}
              onClick={() => setDownloadedTwo(true)}
            />
          </Grid>
        </Grid>

        <Grid item container spacing={3}>
          <Grid item xs={8}>
            <CommonSelect
              id="payment"
              label={t("Payment method")}
              placeholder={t("Select...")}
              values={values}
              errors={errors}
              touched={touched}
              setFieldValue={setFieldValue}
              options={paymentOptions}
            />
          </Grid>

          <Grid item xs={4}>
            <Button
              className="primary--medium"
              onClick={onAddPaymentMethods}
              style={{}}
              fullWidth
              variant="contained"
            >
              {t("Add Payment")}
            </Button>
          </Grid>
        </Grid>
      </Grid>

      <ShareInfo />

      <Grid container direction="column">
        <Grid item>
          <CommonCheckbox
            id="agreement1"
            disabled={!downloadedOne}
            values={values}
            errors={errors}
            touched={touched}
            setFieldValue={setFieldValue}
            label={t(
              "I have downloaded the prospectus including the loan terms and cancelation policies, read them and printed them out or safely stored them"
            )}
          />
        </Grid>

        <Grid item>
          <CommonCheckbox
            id="agreement2"
            disabled={!downloadedTwo}
            values={values}
            errors={errors}
            touched={touched}
            setFieldValue={setFieldValue}
            label={t(
              "I have downloaded, read and safely stored the agent information document."
            )}
          />
        </Grid>
      </Grid>
    </Card>
  );
};
